import React from 'react';
import { Controller, ControllerProps, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { DISPOSAL_PURPOSE } from '@schuettflix/interfaces';
import { SelectCombobox } from '@/shared/ui/Combobox/SelectCombobox.tsx';

type DisposalOption = { value: DISPOSAL_PURPOSE; label: string; description: string };

export type DisposalPurposeProps = Pick<ControllerProps, 'defaultValue' | 'name'> & {
    variant?: 'lg' | 'md';
    placeholder?: string;
    disabled?: boolean;
    dataTest?: string;
    className?: string;
};

export const DisposalPurposeInput: React.FC<DisposalPurposeProps> = React.forwardRef<
    HTMLInputElement,
    DisposalPurposeProps
>(({ name = 'disposalProcedure', defaultValue, placeholder, disabled, variant = 'lg', dataTest, className }, _ref) => {
    const { control } = useFormContext();
    const { t } = useTranslation();

    const options: DisposalOption[] = [
        {
            value: 'RECYCLING',
            label: t('forms.inputs.disposalProcedureInput.recycling.label'),
            description: t('forms.inputs.disposalProcedureInput.recycling.description'),
        },
        {
            value: 'DISPOSAL',
            label: t('forms.inputs.disposalProcedureInput.disposal.label'),
            description: t('forms.inputs.disposalProcedureInput.disposal.description'),
        },
    ];

    return (
        <Controller
            control={control}
            defaultValue={defaultValue ?? null}
            name={name}
            render={({ field: { ref, value, onChange }, fieldState }) => (
                <SelectCombobox
                    fieldRef={ref}
                    value={value ?? undefined}
                    onValueChange={disposalPurpose => onChange(disposalPurpose)}
                    options={options}
                    disabled={disabled}
                    placeholder={placeholder ?? 'Disposal Purpose'}
                    error={fieldState.error?.message}
                    size={variant}
                    dataTest={dataTest}
                    className={className}
                />
            )}
        />
    );
});
